import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookmarkIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 25,
	viewBox: "0 0 11 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 20L5.5 15.5294L1 20V1H10V20Z",
		fill: "#DAD9EF",
		stroke: "#7284FA",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBookmarkIcon;
